import { render, staticRenderFns } from "./AnxModal.vue?vue&type=template&id=3d074454&scoped=true&"
import script from "./AnxModal.vue?vue&type=script&lang=ts&"
export * from "./AnxModal.vue?vue&type=script&lang=ts&"
import style0 from "./AnxModal.vue?vue&type=style&index=0&id=3d074454&lang=scss&scoped=true&"
import style1 from "./AnxModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d074454",
  null
  
)

export default component.exports